import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getPaymentPermissions } from '../../constants/payments';
import { PaymentType } from '@wix/wix-vod-constants/api-types';
import { withTranslation } from '@wix/yoshi-flow-editor';
import {
  getRentPriceInfo,
  getSalePriceInfo,
  getSubscriptionPriceInfo,
  getDealInfoByType,
} from '@wix/wix-vod-shared/common';

import DealInfo from '../payments/deal-info';

import { paymentPermissionTranslations } from '../../constants/translations';
import { isVideoDownloadEnabled } from '../../selectors/downloads';

import { Switch } from './switch/switch';

import styles from './item-info.scss';
import { isRTL } from '../../selectors/app-settings';

const mapStateToProps = (state, { itemData }) => ({
  downloadEnabled: isVideoDownloadEnabled(itemData),
  isRTL: isRTL(state),
});

const ItemInfo = connect(mapStateToProps)(
  class ItemInfo extends React.Component {
    static propTypes = {
      paymentType: PropTypes.string.isRequired,
      downloadEnabled: PropTypes.bool,
      itemData: PropTypes.object.isRequired,
      onSelectPaymentType: PropTypes.func,
      isRTL: PropTypes.bool.isRequired,
    };

    handleChange = (event) => {
      _.invoke(this.props, 'onSelectPaymentType', event.target.value);
    };

    renderButtons(paymentType, itemData) {
      if (paymentType === PaymentType.SUBSCRIPTION) {
        return (
          <div className={styles['disabled-button']}>
            <DealInfo {...getSubscriptionPriceInfo(itemData.dealInfo)} />
          </div>
        );
      }

      if (paymentType === PaymentType.MEMBER_ONLY) {
        return (
          <div className={styles['disabled-button']}>
            {this.props.t('widget.payments.member-only-benefits')}
          </div>
        );
      }

      const rentDealInfo = getRentPriceInfo(itemData.dealInfo);
      const purchaseDealInfo = getSalePriceInfo(itemData.dealInfo);

      if (!rentDealInfo || !purchaseDealInfo) {
        return (
          <div className={styles['disabled-button']}>
            <DealInfo {...(rentDealInfo || purchaseDealInfo)} />
          </div>
        );
      }

      return this.renderResponsivePurchaseOptions(paymentType, {
        rentDealInfo,
        purchaseDealInfo,
      });
    }

    renderResponsivePurchaseOptions(
      paymentType,
      { rentDealInfo, purchaseDealInfo },
    ) {
      return (
        <div className={styles.paymentOptions}>
          <Switch
            name="paymentType"
            value={paymentType}
            isRTL={this.props.isRTL}
            onChange={this.handleChange}
            options={[
              {
                value: PaymentType.RENT,
                label: <DealInfo {...rentDealInfo} />,
                className: styles.switchOption,
              },
              {
                value: PaymentType.PURCHASE,
                label: <DealInfo {...purchaseDealInfo} />,
                className: styles.switchOption,
              },
            ]}
          />
        </div>
      );
    }

    render() {
      const { paymentType, itemData, downloadEnabled } = this.props;
      const dealInfo = getDealInfoByType(itemData.dealInfo, paymentType);
      const permissions = getPaymentPermissions({
        paymentType,
        downloadEnabled,
      });

      return (
        <div className={styles.responsiveWrapper}>
          <div id="payment-item">
            {this.renderButtons(paymentType, itemData)}
          </div>

          <ul className={styles.permissions}>
            {_.map(permissions, (permTitle) => (
              <li className={styles.permission} key={permTitle}>
                {this.props.t(
                  paymentPermissionTranslations[permTitle],
                  dealInfo,
                )}
              </li>
            ))}
          </ul>
        </div>
      );
    }
  },
);

export default withTranslation()(ItemInfo);
